import { useTranslation } from 'react-i18next';

import { ContentfulEntry, TranslationNamespace } from '../types';

export const useContentfulTranslation = () => {
  const { t, i18n, ready } = useTranslation(TranslationNamespace.CONTENTFUL);

  const getContentfulEntry = (key: string): ContentfulEntry | null => {
    const entry = t(key, { returnObjects: true }) as ContentfulEntry;
    return entry?.body ? entry : null;
  };

  return {
    getContentfulEntry,
    isReady: ready,
    currentLocale: i18n.language,
  };
};
